// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__sYL_J","boxTitle":"Qualiphy_boxTitle__2dYXU","box":"Qualiphy_box__V0ikM","toggleWrap":"Qualiphy_toggleWrap__-PT2V"};